<script setup lang="ts">
const localePath = useLocalePath()
const baseStore = useBaseStore()

// Promo data
const promo = computed(() => baseStore.promos)
const promoPercentage = computed(() => {
  if (promo.value?.percentage) {
    const percentage = Number.parseFloat(promo.value.percentage)
    return Math.round(percentage)
  }
  return null
})

// Computed properties for dynamic styling
const promoBackground = computed(() => {
  if (promo.value?.banner_bg_from && promo.value?.bg_from_to) {
    return `linear-gradient(135deg, ${promo.value.banner_bg_from} 0%, ${promo.value.bg_from_to} 100%)`
  }
  return 'linear-gradient(135deg, #ff6b35 0%, #f7931e 50%, #ff4757 100%)'
})

const promoTextColor = computed(() => promo.value?.title_color || '#FFFFFF')

const menuItems = [
  {
    label: 'Accueil',
    icon: 'i-custom-menu-home',
    to: localePath({ name: 'IndexPage' }),
  },
  {
    label: 'Économies',
    icon: 'i-custom-menu-flyers',
    to: localePath({ name: 'FlyersPage' }),
    children: [
      {
        label: 'Circulaires',
        to: localePath({ name: 'FlyersPage' }),
      },
      {
        label: 'Prix de l\'essence',
        to: localePath({ name: 'GasPricePage' }),
      },
      {
        label: 'Produits suivis',
        to: localePath({ name: 'TrackedIngredientsPage' }),
      },
    ],
  },
  {
    label: 'Recettes',
    icon: 'i-custom-menu-recipes',
    to: localePath({ name: 'RecipesPage' }),
    children: [
      {
        label: 'Recettes & vide-frigo',
        to: localePath({ name: 'RecipesPage' }),
      },
      {
        label: 'L\'économiseur',
        to: localePath({ name: 'MoneySaverPage' }),
      },
    ],
  },
  {
    label: 'Listes',
    icon: 'i-custom-menu-lists',
    to: localePath({ name: 'ShoppingListPage' }),
    children: [
      {
        label: 'Liste d\'épicerie',
        to: localePath({ name: 'ShoppingListPage' }),
      },
      {
        label: 'Boîte de recettes',
        to: localePath({ name: 'RecipeBoxPage' }),
      },
      {
        label: 'Planificateur de menus',
        to: localePath({ name: 'MealPlannerPage' }),
      },
    ],
  },

  {
    label: 'Rabais',
    icon: 'i-custom-menu-discounts',
    to: localePath({ name: 'ExtraDiscountsPage' }),
  },
  {
    label: 'Blogue',
    icon: 'i-custom-menu-blogs',
    to: localePath({ name: 'ArticlesPage' }),
  },
  {
    label: 'Extra',
    icon: 'i-custom-rounded-star',
    to: localePath({ name: 'ExtraPage' }),
    showPromo: true,
  },
]
</script>

<template>
  <div
    id="default"
    :min-size="12"
    class="bg-default h-screen xl:w-55 overflow-y-auto"
  >
    <div class="h-16 bg-tomate flex items-center">
      <ULink class="ml-4" :to="$localePath({ name: 'IndexPage' })">
        <img class="h-7 w-auto shrink-0" src="/images/logo-white.svg">
      </ULink>
    </div>
    <div class="flex flex-col mt-2">
      <div v-for="section in menuItems" :key="section.label" class="border-b border-gray-200 space-y-1 py-1">
        <ULink class="flex space-x-3 items-center px-4 hover:bg-tomate-100 w-full py-2" :to="section.to">
          <div class="flex items-center justify-center bg-tomate h-10 w-10 rounded-lg">
            <UIcon :name="section.icon" class="size-6 text-white" />
          </div>
          <div class="uppercase font-semibold text-poivre-800">
            {{ section.label }} <span v-if="section.showPromo && promo && promoPercentage && baseStore.shouldShowPromos" class="ml-2 pointer-events-none overflow-hidden">
              <span class="promo-badge text-center text-sm ml-auto rounded-lg py-1 px-2 shadow-lg relative overflow-hidden" :style="{ background: promoBackground, color: promoTextColor }">
                -{{ promoPercentage }}%
              </span>
            </span>
          </div>
        </ULink>
        <div v-if="section.children" class="space-y-1">
          <ULink v-for="link in section.children" :key="link.label" class="hover:bg-tomate-100 w-full text-left px-4 py-2 flex text-poivre-700" :to="link.to">
            {{ link.label }}
          </ULink>
        </div>
      </div>
    </div>
  </div>
</template>
